import React from "react";
import { Dropdown } from "@learningblocks/shared-components";

export class SelectDropdown extends React.Component {
  getOptions = () => {
    return this.props.options.map((option) => ({
      ...option,
      value: option.id,
      name: this.props.name,
      label: option.text,
    }));
  };

  render() {
    return (
      <>
        <label className="dropdown-label" htmlFor={this.props.name}>
          {this.props.label}
        </label>
        <Dropdown
          className="dropdown-select"
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          value={this.props.value}
          disabled={this.props.disabled}
          options={this.getOptions()}
        ></Dropdown>
      </>
    );
  }
}
